import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import {
  RHFAutocomplete,
  RHFCheckbox,
  RHFDateTimePicker,
  RHFRadioGroup,
  RHFTextField,
} from "../../../../../RHFComponents/RHFComponents";
import { UseFormReturn } from "react-hook-form";
import { AllertMessage } from "../Agenda/MedintAgendaForm/MedintAgendaFormDetail";
import { StyledDataGrid } from "../../../../../AppointmentManagement/AppointmentManagementDetail/AppointmentManagementDetail";
import { ReactComponent as ModifyIcon } from "../../../../../../assets/icons/MedintModifyIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/icons/MedintDeleteIcon.svg";
import { ReactComponent as AddIcon } from "../../../../../../assets/icons/MedintAddIcon.svg";
import { GridColDef } from "@mui/x-data-grid";
import { GridSelectionModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import {
  DistrAssRow,
  DistrDefaultRow,
  MedPrestDistr,
  MedPrestMetodiche,
  MethodsDefaultRow,
  MetodAssRow,
} from "./MedPrest";
import {
  PayloadRicGPMetod,
  ResponseRicAnaPre,
  ResponseRicGPDistr,
  ResponseRicGPMetod,
} from "../../../../../../services/medintInterfaces";
import dayjs from "dayjs";
import {
  medprstgpd,
  medprstgpm,
  ricGPDistr,
  ricGPMetod,
} from "../../../../../../networking";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

type ModalView = "base" | "distretti" | "metodiche";
type InsertType = "singola" | "multipla";
type AlertObject = {
  showAllert: boolean;
  message: string;
  setAllert: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  setSeverity: React.Dispatch<React.SetStateAction<string>>;
  severity: string;
  fn: (() => void) | null;
  setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
};

const gridStyle = {
  height: 200,
  '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
    {
      display: "none",
    },
  "& .MuiDataGrid-row.Mui-selected": {
    backgroundColor: "#e3f2fd",
  },
  "& .MuiDataGrid-row.Mui-selected:hover": {
    backgroundColor: "#bbdefb",
  },
};

const TabsAttributiPres = (props: {
  loading: boolean;
  methods: UseFormReturn<any, undefined>;
  methodsDistr: UseFormReturn<any, undefined>;
  methodsMetod: UseFormReturn<any, undefined>;
  listDistAssoc: DistrAssRow[] | null;
  listMetodAssoc: MetodAssRow[] | null;
  listDistDefault: DistrDefaultRow[] | null;
  listMetodDefault: MethodsDefaultRow[] | null;
  showModale: boolean;
  setShowModale: (value: boolean) => void;
  submitFunction: () => Promise<void>;
  defaultView: boolean;
  selectedTab: number;
  setSelectedTab: (value: number) => void;
  setModalsView: React.Dispatch<React.SetStateAction<ModalView>>;
  payloadMetodicaHandler: (data: any) => Promise<void>;
  payloadDistrettoHandler: (data: any) => Promise<void>;
  deleteRequestMetodica: (data: any) => Promise<void>;
  deleteRequestDistretti: (data: any) => Promise<void>;
  distrettiSelected: DistrDefaultRow[] | undefined;
  setDistrettiSelected: React.Dispatch<
    React.SetStateAction<DistrDefaultRow[] | undefined>
  >;
  metodicheSelected: MethodsDefaultRow[] | undefined;
  setMetodicheSelected: React.Dispatch<
    React.SetStateAction<MethodsDefaultRow[] | undefined>
  >;
}) => {
  // states per la gestione delle selezioni sulla vista dei default
  const [selectionModel, setSelectionModel] = useState<
    GridSelectionModel | undefined
  >();

  useEffect(() => {
    setSelectionModel([]);
  },[props.selectedTab])

  useEffect(() => {
    if (props.selectedTab === 0) {
      const selectedRows = props?.listDistDefault?.filter((row) =>
        selectionModel?.includes(row.id),
      );
      props.setDistrettiSelected(selectedRows);
    } else if (props.selectedTab === 1) {
      const selectedRows = props?.listMetodDefault?.filter((row) =>
        selectionModel?.includes(row.id),
      );
      props.setMetodicheSelected(selectedRows);
    } else {
      return;
    }
  }, [selectionModel]);

  const handleEditMetodica = (data: any) => {
    props.methodsMetod.reset({
      crud: "u",
      codiceSiss: data.ANAPRES_SISS_COD,
      metodica: data.GPMETOD_CODICE,
      dataIni: dayjs(data.MEDPRSTGPM_DT_INI_VAL, "YYYY-MM-DD"),
      dataFin: dayjs(data.MEDPRSTGPM_DT_FINE_VAL, "YYYY-MM-DD"),
      abbDisatt: data.MEDPRSTGPM_SW_DISABILITATO === "1" ? true : false,
      prgintMetod: data.MEDPRSTGPM_PRGINT,
    });

    props.setModalsView("metodiche");
  };
  const handleEditDistretti = (data: any) => {
    props.methodsDistr.reset({
      crud: "u",
      codiceSiss: data.ANAPRES_SISS_COD,
      distretto: data.GPDISTR_CODICE,
      dataIni: dayjs(data.MEDPRSTGPD_DT_INI_VAL, "YYYY-MM-DD"),
      dataFin: dayjs(data.MEDPRSTGPD_DT_FINE_VAL, "YYYY-MM-DD"),
      abbDisatt: data.MEDPRSTGPD_SW_DISABILITATO === "1" ? true : false,
      opLogico: data.MEDPRSTGPD_OP_LOGICO,
      prgintDistr: data.MEDPRSTGPD_PRGINT,
    });

    props.setModalsView("distretti");
  };

  const distrettoCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      // field: "codDistr",
      field: "GPDISTR_CODICE",
      headerName: "Cod. Distretto",
      flex: 1,
    },
    {
      // field: "desDistr",
      field: "DECODE_GPDISTR_GPDISTR_DESCRIZIONE",
      headerName: "Descr. Distretto",
      flex: 1,
    },
    {
      // field: "codiceSISS",
      field: "ANAPRES_SISS_COD",
      headerName: "Codice SISS",
      flex: 1,
    },
    {
      // field: "opLogico",
      field: "MEDPRSTGPD_OP_LOGICO",
      headerName: "Op. Logico",
      flex: 1,
    },
    {
      field: "azioni",
      headerAlign: "center",
      align: "center",
      headerName: "Azioni",
      flex: 0.5,
      renderCell: (params: any) => (
        <>
          <IconButton
            size="small"
            onClick={() => handleEditDistretti(params.row)}
            sx={{
              color: "#024E88",
            }}
          >
            <ModifyIcon />
          </IconButton>

          <IconButton
            size="small"
            onClick={(e) => {
              props.deleteRequestDistretti(params.row);
            }}
            sx={{
              color: "#D32F2F",
            }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];
  const distrettoDefaultCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      field: "GPDISTR_CODICE",
      headerName: "Cod. Distretto",
      flex: 1,
    },
    {
      field: "DECODE_GPDISTR_GPDISTR_DESCRIZIONE",
      headerName: "Descr. Distretto",
      flex: 1,
    },
    {
      field: "DECODE_ANAPRES_ANAPRES_SISS_COD",
      headerName: "Codice SISS",
      flex: 1,
    },
    {
      field: "PRESTGPD_OP_LOGICO",
      headerName: "Op. Logico",
      flex: 1,
    },
  ];
  const metodicheCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      field: "DECODE_MEDPREST_SPECIA_CODICE",
      headerName: "Cod. Metodica",
      flex: 0.6,
    },
    {
      field: "DECODE_GPMETOD_GPMETOD_DESCRIZIONE",
      headerName: "Descr. Metodica",
      flex: 1,
    },
    {
      field: "ANAPRES_SISS_COD",
      headerName: "Codice SISS",
      flex: 1,
    },
    {
      field: "azioni",
      headerAlign: "center",
      align: "center",
      headerName: "Azioni",
      flex: 0.5,
      renderCell: (params: any) => (
        <>
          <IconButton
            size="small"
            onClick={() => handleEditMetodica(params.row)}
            sx={{
              color: "#024E88",
            }}
          >
            <ModifyIcon />
          </IconButton>

          <IconButton
            size="small"
            onClick={() => props.deleteRequestMetodica(params.row)}
            sx={{
              color: "#D32F2F",
            }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];
  const metodicheDefaultCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      field: "GPMETOD_CODICE",
      headerName: "Cod. Metodica",
      flex: 1,
    },
    {
      field: "DECODE_GPMETOD_GPMETOD_DESCRIZIONE",
      headerName: "Descr. Metodica",
      flex: 1,
    },
    {
      field: "DECODE_ANAPRES_ANAPRES_SISS_COD",
      headerName: "Codice SISS",
      flex: 1,
    },
  ];

  //Cambia lo stato selectedTab da 0 a 1 in base alla Tab selezionata dall'utente
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    props.setSelectedTab(newValue);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tabs value={props.selectedTab} onChange={handleTabChange}>
          <Tab
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
              textTransform: "none",
            }}
            label="Distretto"
          />
          <Tab
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
              textTransform: "none",
            }}
            label="Metodiche"
          />
        </Tabs>
      </Grid>
      {props.defaultView && (
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          <Button
            variant="outlined"
            onClick={
              props.selectedTab === 0
                ? () => {
                    props.setModalsView("distretti");
                    props.methodsDistr.setValue("crud", "c");
                  }
                : () => {
                    props.setModalsView("metodiche");
                    props.methodsMetod.setValue("crud", "c");
                  }
            }
          >
            <Stack gap={1} direction="row">
              <AddIcon className="medintIcons" />
              <Typography sx={{ fontWeight: "bold" }}>Inserisci</Typography>
            </Stack>
          </Button>
        </Grid>
      )}
      {props.selectedTab === 0 && (
        <Grid item xs={12} mt={2}>
          <StyledDataGrid
            rows={
              props.defaultView
                ? (props.listDistAssoc ?? [])
                : (props.listDistDefault?.filter(
                    (elemento) =>
                      !props?.listDistAssoc?.find(
                        (assoc) =>
                          assoc.GPDISTR_CODICE === elemento.GPDISTR_CODICE,
                      ),
                  ) ?? [])
            }
            loading={props.loading}
            columns={props.defaultView ? distrettoCols : distrettoDefaultCols}
            getRowId={(r) => r.id}
            checkboxSelection={!props.defaultView}
            columnVisibilityModel={{
              id: false,
              azioni: props.defaultView,
            }}
            selectionModel={selectionModel ?? []}
            onSelectionModelChange={(newSelection: GridSelectionModel) => {
              setSelectionModel(newSelection);
            }}
            onRowClick={
              !props.defaultView
                ? (event: any) => {
                    console.log(event.row);
                  }
                : undefined
            }
            sortingOrder={["desc", "asc", null]}
            sx={gridStyle}
          />
        </Grid>
      )}

      {props.selectedTab === 1 && (
        <Grid item xs={12} mt={2}>
          <StyledDataGrid
            rows={
              props.defaultView
                ? (props.listMetodAssoc ?? [])
                : (props.listMetodDefault?.filter(
                    (elemento) =>
                      !props?.listMetodAssoc?.find(
                        (assoc) =>
                          assoc.GPMETOD_CODICE === elemento.GPMETOD_CODICE,
                      ),
                  ) ?? [])
            }
            loading={props.loading}
            columns={props.defaultView ? metodicheCols : metodicheDefaultCols}
            getRowId={(r) => r.id}
            checkboxSelection={!props.defaultView}
            columnVisibilityModel={{
              id: false,
              azioni: props.defaultView,
            }}
            selectionModel={selectionModel ?? []}
            onSelectionModelChange={(newSelection: GridSelectionModel) => {
              setSelectionModel(newSelection);
            }}
            onRowClick={
              !props.defaultView
                ? (event: any) => {
                    console.log(event.row);
                  }
                : undefined
            }
            sortingOrder={["desc", "asc", null]}
            sx={gridStyle}
          />
        </Grid>
      )}
    </Grid>
  );
};

const DistrettoModal = (props: {
  loading: boolean;
  methods: UseFormReturn<any, undefined>;
  codiciSiss: ResponseRicAnaPre[] | undefined;
  setModalsView: React.Dispatch<React.SetStateAction<ModalView>>;
  submitFunction: () => Promise<void>;
  payloadDistrettoHandler: (data?: any) => Promise<void>;
}) => {
  const [disabledBySiss, setDisabledBySiss] = useState<boolean>(true);
  const [tipologiaInserimento, setTipologiaInserimento] =
    useState<InsertType>("singola");
  const [listaDistretti, setListaDistretti] = useState<ResponseRicGPDistr[]>(
    [],
  );
  const [selectionModel, setSelectionModel] = useState<
    GridSelectionModel | undefined
  >();
  const [distrettiSelected, setDistrettiSelected] =
    useState<ResponseRicGPDistr[]>();

  const insMultCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      field: "CODGPDISTR",
      headerName: "Codice",
      flex: 1,
    },
    {
      field: "DESGPDISTR",
      headerName: "Descrizione",
      flex: 1,
    },
    {
      field: "DATAINIVAL",
      headerName: "Inizio Validità",
      flex: 1,
      renderCell(params) {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "DATAFINEVAL",
      headerName: "Fine Validità",
      flex: 1,
      renderCell(params) {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
  ];

  useEffect(() => {
    if (
      props.methods.getValues("codiceSiss") !== "null" &&
      props.methods.getValues("codiceSiss") !== null
    ) {
      uploadDistretti();
    } else {
      setDisabledBySiss(true);
    }
  }, [props.methods.watch("codiceSiss")]);

  useEffect(() => {
    const selectedRows = listaDistretti.filter((row) =>
      selectionModel?.includes(row.id),
    );
    setDistrettiSelected(selectedRows);
  }, [selectionModel]);

  // funzione per gestire il payload dei distretti da aggiornare
  const uploadDistretti = async () => {
    const tempObj: PayloadRicGPMetod = {
      aziendaPrenotazione: "MEDITEL",
      dataRif: dayjs().format("YYYY-MM-DD"),
      codAnapres: props.methods.getValues("codiceSiss"),
    };

    try {
      await ricGPDistr(tempObj)
        .then((response: any) => {
          const mapDati: ResponseRicGPDistr[] =
            response?.data?.dati?.gpdistr?.map(
              (e: ResponseRicGPDistr, index: number) => {
                return {
                  id: index,
                  CODGPDISTR: e.CODGPDISTR,
                  DESGPDISTR: e.DESGPDISTR,
                  DATAINIVAL: e.DATAINIVAL,
                  DATAFINEVAL: e.DATAFINEVAL,
                } as ResponseRicGPDistr;
              },
            );
          setListaDistretti(mapDati);
        })
        .finally(() => setDisabledBySiss(false));
    } catch (error) {
      console.error("Errore sull'invio del payload di medpresl:", error);
    }
  };

  return (
    <>
      <Tabs value={0} sx={{ paddingLeft: 2, mb: 2 }}>
        <Tab
          sx={{
            fontFamily: "Montserrat",
            fontWeight: "bold",
            textTransform: "none",
          }}
          label={
            tipologiaInserimento === "singola"
              ? "Distretto - Dettaglio"
              : "Inserimento Multiplo Distretti - Dettaglio"
          }
        />
      </Tabs>
      <Grid container spacing={2} p={2}>
        {tipologiaInserimento === "singola" ? (
          <>
            <Grid item xs={12} md={6}>
              <RHFAutocomplete
                control={props.methods.control}
                name="codiceSiss"
                label="Codice prestazione SISS"
                fullWidth
                options={props.codiciSiss ?? []}
                // rules={{ required: "Campo obbligatorio" }}
                getOptionLabel={(option) =>
                  `[${option.CODANAPRES ?? option.CODANAPRE ?? "N/a"}] ${option.DESANAPRE ?? "N/a"}`
                }
                mapIn={(code, opts) =>
                  opts.find(
                    (o: any) =>
                      String(o?.CODANAPRES).trim() === String(code).trim(),
                  ) ??
                  opts.find(
                    (o: any) =>
                      String(o?.CODANAPRE).trim() === String(code).trim(),
                  ) ??
                  null
                }
                mapOut={(opt: any) =>
                  String(opt?.CODANAPRES ?? opt?.CODANAPRE ?? null)
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFAutocomplete
                control={props.methods.control}
                name="distretto"
                label="Distretto"
                disabled={disabledBySiss}
                fullWidth
                options={listaDistretti ?? []}
                getOptionLabel={(q: any) =>
                  `${String(q.CODGPDISTR ?? "").trim()} - ${String(q.DESGPDISTR ?? "").trim()}`
                }
                mapIn={(code, opts) =>
                  opts.find(
                    (o: any) =>
                      String(o.CODGPDISTR).trim() === String(code).trim(),
                  ) ?? null
                }
                mapOut={(opt: any) => {
                  props.methods.setValue(
                    "dataIni",
                    dayjs(opt?.DATAINIVAL, "YYYY-MM-DD"),
                  );
                  props.methods.setValue(
                    "dataFin",
                    dayjs(opt?.DATAFINEVAL, "YYYY-MM-DD"),
                  );
                  return String(opt?.CODGPDISTR ?? "");
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{ minWidth: 150, fontWeight: 500 }}>
                  Operatore logico:
                </Box>
                <RHFRadioGroup
                  control={props.methods.control}
                  name="opLogico"
                  row
                  options={[
                    { value: "U", label: "Uguale" },
                    { value: "D", label: "Diverso" },
                  ]}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFDateTimePicker
                control={props.methods.control}
                name="dataIni"
                label="Data Inizio Validita"
                serialize="dayjs"
                disabled={
                  props.methods.watch("distretto") === null || disabledBySiss
                }
                fullWidth
                dateOnly
                displayFormat="DD/MM/YY"
                valueFormat="YYYY-MM-DD"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFDateTimePicker
                control={props.methods.control}
                name="dataFin"
                label="Data Fine Validita"
                serialize="dayjs"
                disabled={
                  props.methods.watch("distretto") === null || disabledBySiss
                }
                fullWidth
                dateOnly
                displayFormat="DD/MM/YY"
                valueFormat="YYYY-MM-DD"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFCheckbox
                control={props.methods.control}
                name="abbDisatt"
                label="Abbinamento Disattivato"
              />
            </Grid>
            <Grid item xs={12} md={6}></Grid>
          </>
        ) : (
          <Grid
            container
            display={"flex"}
            sx={{
              borderRadius: "4px",
              border: "1px solid #CCC",
              ml: 2,
              mt: 2,
              pb: 2,
              pr: 2,
              pl: 2,
            }}
          >
            <Grid
              item
              xs={12}
              display={"flex"}
              justifyContent={"flex-end"}
              pt={2}
              pb={2}
            >
              <RHFCheckbox
                control={props.methods.control}
                name="abbDisatt"
                label="Mostra disabilitati"
              />
            </Grid>
            <Grid item xs={12}>
              <StyledDataGrid
                rows={listaDistretti ?? []}
                columns={insMultCols}
                getRowId={(r) => r.id}
                loading={props.loading}
                checkboxSelection
                selectionModel={selectionModel ?? []}
                onSelectionModelChange={(newSelection: GridSelectionModel) => {
                  setSelectionModel(newSelection);
                }}
                columnVisibilityModel={{
                  id: false,
                }}
                sortingOrder={["desc", "asc", null]}
                sx={gridStyle}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Button
            variant="outlinedCustom"
            size="small"
            onClick={() => {
              props.setModalsView("base");
              setDistrettiSelected([]);
              setSelectionModel([]);
              setTipologiaInserimento("singola");
              setDisabledBySiss(true);
              props.methods.reset();
            }}
          >
            {" "}
            Indietro
          </Button>
          <Stack direction={"row"} gap={2}>
            {tipologiaInserimento === "singola" && (
              <Button
                variant="outlined"
                size="small"
                disabled={disabledBySiss}
                onClick={() => setTipologiaInserimento("multipla")}
              >
                {" "}
                Inserimento Multiplo
              </Button>
            )}
            <Button
              variant="containedCustom"
              size="small"
              disabled={
                props.methods.watch("distretto") === null || disabledBySiss
              }
              onClick={props.methods.handleSubmit(async () => {
                const tempList = distrettiSelected ?? [];

                if (tempList.length === 0) {
                  await props.payloadDistrettoHandler().finally(() => {
                    props.setModalsView("base");
                    setTipologiaInserimento("singola");
                    setDistrettiSelected([]);
                    setSelectionModel([]);
                  });
                } else {
                  await Promise.all(
                    tempList.map((e) =>
                      props.payloadDistrettoHandler({
                        CODGPDISTR: e.CODGPDISTR,
                        DATAINIVAL: e.DATAINIVAL,
                        DATAFINEVAL: e.DATAFINEVAL,
                      }),
                    ),
                  ).finally(() => {
                    props.setModalsView("base");
                    setTipologiaInserimento("singola");
                    setDistrettiSelected([]);
                    setSelectionModel([]);
                  });
                }
              })}
            >
              {" "}
              Conferma
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

const MetodicaModal = (props: {
  loading: boolean;
  methods: UseFormReturn<any, undefined>;
  codiciSiss: ResponseRicAnaPre[] | undefined;
  setModalsView: React.Dispatch<React.SetStateAction<ModalView>>;
  submitFunction: () => Promise<void>;
  payloadMetodicaHandler: (data?: any) => Promise<void>;
}) => {
  const [disabledBySiss, setDisabledBySiss] = useState<boolean>(true);
  const [tipologiaInserimento, setTipologiaInserimento] =
    useState<InsertType>("singola");
  const [listaMetodiche, setListaMetodiche] = useState<ResponseRicGPMetod[]>(
    [],
  );
  const [selectionModel, setSelectionModel] = useState<
    GridSelectionModel | undefined
  >();
  const [metodicSelected, setMetodicaSelected] =
    useState<ResponseRicGPMetod[]>();

  const insMultCols: GridColDef[] = [
    {
      field: "id",
    },
    {
      field: "CODGPMETOD",
      headerName: "Codice",
      flex: 0.5,
    },
    {
      field: "DESGPMETOD",
      headerName: "Descrizione",
      flex: 1,
    },
    {
      field: "DATAINIVAL",
      headerName: "Inizio Validità",
      flex: 0.8,
      renderCell(params) {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "DATAFINEVAL",
      headerName: "Fine Validità",
      flex: 0.8,
      renderCell(params) {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
  ];

  useEffect(() => {
    if (
      props.methods.getValues("codiceSiss") !== "null" &&
      props.methods.getValues("codiceSiss") !== null
    ) {
      uploadMetodiche();
    } else {
      setDisabledBySiss(true);
    }
  }, [props.methods.watch("codiceSiss")]);

  useEffect(() => {
    const selectedRows = listaMetodiche.filter((row) =>
      selectionModel?.includes(row.id),
    );
    setMetodicaSelected(selectedRows);
  }, [selectionModel]);

  // funzione per gestire il payload della metodica da aggiornare
  const uploadMetodiche = async () => {
    const tempObj = {
      aziendaPrenotazione: "MEDITEL",
      dataRif: dayjs().format("YYYY-MM-DD"),
      codAnapres: props.methods.getValues("codiceSiss"),
    };

    try {
      await ricGPMetod(tempObj)
        .then((response: any) => {
          const mapDati: ResponseRicGPMetod[] =
            response?.data?.dati?.gpmetod?.map(
              (e: ResponseRicGPMetod, index: number) => {
                return {
                  id: index,
                  DATAINIVAL: e.DATAINIVAL,
                  DATAFINEVAL: e.DATAFINEVAL,
                  CODGPMETOD: e.CODGPMETOD,
                  DESGPMETOD: e.DESGPMETOD,
                } as ResponseRicGPMetod;
              },
            );
          setListaMetodiche(mapDati);
        })
        .finally(() => setDisabledBySiss(false));
    } catch (error) {
      console.error("Errore sull'invio del payload di medpresl:", error);
    }
  };

  return (
    <>
      <Tabs value={0} sx={{ paddingLeft: 2, mb: 2 }}>
        <Tab
          sx={{
            fontFamily: "Montserrat",
            fontWeight: "bold",
            textTransform: "none",
            width: "100%",
          }}
          label={
            tipologiaInserimento === "singola"
              ? "Metodica - Dettaglio"
              : "Inserimento Multiplo Metodiche - Dettaglio"
          }
        />
      </Tabs>
      <Grid container spacing={2} p={2}>
        {tipologiaInserimento === "singola" ? (
          <>
            <Grid item xs={12} md={6}>
              <RHFAutocomplete
                control={props.methods.control}
                name="codiceSiss"
                label="Codice prestazione SISS"
                fullWidth
                options={props.codiciSiss ?? []}
                // rules={{ required: "Campo obbligatorio" }}
                getOptionLabel={(option) =>
                  `[${option.CODANAPRES ?? option.CODANAPRE ?? "N/a"}] ${option.DESANAPRE ?? "N/a"}`
                }
                mapIn={(code, opts) =>
                  opts.find(
                    (o: any) =>
                      String(o?.CODANAPRES).trim() === String(code).trim(),
                  ) ??
                  opts.find(
                    (o: any) =>
                      String(o?.CODANAPRE).trim() === String(code).trim(),
                  ) ??
                  null
                }
                mapOut={(opt: any) =>
                  String(opt?.CODANAPRES ?? opt?.CODANAPRE ?? null)
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFAutocomplete
                control={props.methods.control}
                name="metodica"
                label="Metodica"
                disabled={disabledBySiss}
                fullWidth
                options={listaMetodiche ?? []}
                // rules={{ required: "Campo obbligatorio" }}
                getOptionLabel={(option) =>
                  `[${option.CODGPMETOD ?? "N/a"}] ${option.DESGPMETOD ?? "N/a"}`
                }
                mapIn={(code, opts) =>
                  opts.find(
                    (o: any) =>
                      String(o?.CODGPMETOD).trim() === String(code).trim(),
                  ) ??
                  opts.find(
                    (o: any) =>
                      String(o?.CODGPMETOD).trim() === String(code).trim(),
                  ) ??
                  null
                }
                mapOut={(opt: any) => {
                  props.methods.setValue(
                    "dataIni",
                    dayjs(opt?.DATAINIVAL, "YYYY-MM-DD"),
                  );
                  props.methods.setValue(
                    "dataFin",
                    dayjs(opt?.DATAFINEVAL, "YYYY-MM-DD"),
                  );
                  return String(opt?.CODGPMETOD ?? null);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFDateTimePicker
                control={props.methods.control}
                name="dataIni"
                label="Data Inizio Validita"
                serialize="dayjs"
                disabled={
                  props.methods.watch("metodica") === null || disabledBySiss
                }
                fullWidth
                dateOnly
                displayFormat="DD/MM/YY"
                valueFormat="YYYY-MM-DD"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFDateTimePicker
                control={props.methods.control}
                name="dataFin"
                label="Data Fine Validita"
                serialize="dayjs"
                disabled={
                  props.methods.watch("metodica") === null || disabledBySiss
                }
                fullWidth
                dateOnly
                displayFormat="DD/MM/YY"
                valueFormat="YYYY-MM-DD"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFCheckbox
                control={props.methods.control}
                disabled={disabledBySiss}
                name="abbDisatt"
                label="Abbinamento Disattivato"
              />
            </Grid>
          </>
        ) : (
          <Grid
            container
            display={"flex"}
            sx={{
              borderRadius: "4px",
              border: "1px solid #CCC",
              ml: 2,
              mt: 2,
              pb: 2,
              pr: 2,
              pl: 2,
            }}
          >
            <Grid
              item
              xs={12}
              display={"flex"}
              justifyContent={"flex-end"}
              pt={2}
              pb={2}
            >
              <RHFCheckbox
                control={props.methods.control}
                name="abbDisatt"
                label="Mostra disabilitati"
              />
            </Grid>
            <Grid item xs={12}>
              <StyledDataGrid
                rows={listaMetodiche ?? []}
                columns={insMultCols}
                getRowId={(r) => r.id}
                checkboxSelection
                selectionModel={selectionModel ?? []}
                loading={props.loading}
                onSelectionModelChange={(newSelection: GridSelectionModel) => {
                  setSelectionModel(newSelection);
                }}
                columnVisibilityModel={{
                  id: false,
                }}
                sortingOrder={["desc", "asc", null]}
                sx={gridStyle}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Button
            variant="outlinedCustom"
            size="small"
            onClick={() => {
              props.setModalsView("base");
              setMetodicaSelected([]);
              setSelectionModel([]);
              setTipologiaInserimento("singola");
              setDisabledBySiss(true);
              props.methods.reset();
            }}
          >
            {" "}
            Indietro
          </Button>
          <Stack direction={"row"} gap={2}>
            {tipologiaInserimento === "singola" && (
              <Button
                variant="outlined"
                size="small"
                disabled={disabledBySiss}
                onClick={() => setTipologiaInserimento("multipla")}
              >
                {" "}
                Inserimento Multiplo
              </Button>
            )}
            <Button
              variant="containedCustom"
              size="small"
              disabled={
                tipologiaInserimento === "singola"
                  ? props.methods.watch("metodica") === "null" || disabledBySiss
                  : metodicSelected?.length === 0 ||
                    metodicSelected === undefined
              }
              onClick={props.methods.handleSubmit(async () => {
                const tempList = metodicSelected ?? [];

                if (tempList.length === 0) {
                  await props.payloadMetodicaHandler().finally(() => {
                    props.setModalsView("base");
                    setTipologiaInserimento("singola");
                    setMetodicaSelected([]);
                    setSelectionModel([]);
                  });
                } else {
                  await Promise.all(
                    tempList.map((e) =>
                      props.payloadMetodicaHandler({
                        CODGPMETOD: e.CODGPMETOD,
                        DESGPMETOD: e.DESGPMETOD,
                        DATAINIVAL: e.DATAINIVAL,
                        DATAFINEVAL: e.DATAFINEVAL,
                      }),
                    ),
                  ).finally(() => {
                    props.setModalsView("base");
                    setTipologiaInserimento("singola");
                    setMetodicaSelected([]);
                    setSelectionModel([]);
                  });
                }
              })}
            >
              {" "}
              Conferma
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

const AttributiGpModal = (props: {
  methods: UseFormReturn<any, undefined>;
  rowData: any;
  methodsMedDettaglio: UseFormReturn<any, undefined>;
  methodsDistr: UseFormReturn<MedPrestDistr, any, undefined>;
  methodsMetod: UseFormReturn<MedPrestMetodiche, any, undefined>;
  listDistAssoc: DistrAssRow[] | null;
  listMetodAssoc: MetodAssRow[] | null;
  listDistDefault: DistrDefaultRow[] | null;
  listMetodDefault: MethodsDefaultRow[] | null;
  codiciSiss: ResponseRicAnaPre[] | undefined;
  showModale: boolean;
  setShowModale: (value: boolean) => void;
  submitFunction: () => Promise<void>;
  alertProps: AlertObject;
  promisesHandlerAttrGp: () => Promise<void>;
  loading: boolean;
}) => {
  const [defaultView, setDefaultView] = useState<boolean>(true);
  const [modalsView, setModalsView] = useState<ModalView>("base");
  const [selectedTab, setSelectedTab] = useState<number>(0);

  // states per la gestione delle row selezionate durante le rispettive visual default griglia
  const [distrettiSelected, setDistrettiSelected] =
    useState<DistrDefaultRow[]>();
  const [metodicheSelected, setMetodicheSelected] =
    useState<MethodsDefaultRow[]>();

  // funzione per inviare il payload necessario all'inserimento / modifica di una metodica associata
  const payloadMetodicaHandler = async (data: any) => {
    const tempCrud = props.methodsMetod.getValues("crud");
    const validDataIni = dayjs(
      data?.DATAINIVAL ?? props.methodsDistr.getValues("dataIni"),
    );
    const validDataFin = dayjs(
      data?.DATAFINEVAL ?? props.methodsDistr.getValues("dataFin"),
    );

    const tempObj =
      tempCrud === "d"
        ? { crud: tempCrud, prgint: data.MEDPRSTGPM_PRGINT }
        : {
            crud: tempCrud,
            prgint:
              tempCrud === "u"
                ? props.methodsMetod.getValues("prgintMetod")
                : null,
            dati: {
              medprstgpm: {
                MEDPREST_PRGINT: props.rowData.IdMedPrest ?? "",
                ANAPRES_SISS_COD:
                  data?.DECODE_ANAPRES_ANAPRES_SISS_COD ??
                  props.methodsMetod.getValues("codiceSiss") ??
                  "",
                GPMETOD_CODICE:
                  data?.GPMETOD_CODICE ??
                  data?.CODGPMETOD ??
                  props.methodsMetod.getValues("metodica") ??
                  "",
                MEDPRSTGPM_SW_DISABILITATO: props.methodsMetod.getValues(
                  "abbDisatt",
                )
                  ? "1"
                  : "0",
                MEDPRSTGPM_PID_ACU: "0",
                MEDPRSTGPM_TIMESTAMP: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
                MEDPRSTGPM_DT_INI_VAL: validDataIni.isValid()
                  ? validDataIni.format("YYYY-MM-DD")
                  : "",
                MEDPRSTGPD_DT_FINE_VAL: validDataFin.isValid()
                  ? validDataFin.format("YYYY-MM-DD")
                  : "",
              },
            },
          };

    try {
      await medprstgpm(tempObj)
        .then((response: any) => {
          props.alertProps.setAllert(true);
          props.alertProps.setMessage(response.data.messaggio);
          if (response.data.esito === "OK") {
            props.alertProps.setSeverity("success");
          } else {
            props.alertProps.setSeverity("error");
          }
        })
        .finally(() => {
          setTimeout(() => {
            props.alertProps.setAllert(false);
            props.methodsMetod.reset({
              crud: "r",
              abbDisatt: false,
              codiceSiss: null,
              dataFin: null,
              dataIni: null,
              metodica: null,
            });
            props.promisesHandlerAttrGp();
          }, 3000);
        });
    } catch (error) {
      console.error("Errore sull'invio del payload di medpresl:", error);
    }
  };

  // funzione per inviare il payload necessario all'inserimento / modifica di una metodica associata
  const payloadDistrettoHandler = async (data: any) => {
    const tempCrud = props.methodsDistr.getValues("crud");
    const validDataIni = dayjs(
      data?.DATAINIVAL ?? props.methodsDistr.getValues("dataIni"),
    );
    const validDataFin = dayjs(
      data?.DATAFINEVAL ?? props.methodsDistr.getValues("dataFin"),
    );

    const tempObj =
      tempCrud === "d"
        ? { crud: tempCrud, prgint: data.MEDPRSTGPD_PRGINT }
        : {
            crud: tempCrud,
            prgint:
              tempCrud === "u"
                ? props.methodsDistr.getValues("prgintDistr")
                : null,
            dati: {
              medprstgpd: {
                MEDPREST_PRGINT: props.rowData.IdMedPrest ?? "",
                ANAPRES_SISS_COD:
                  data?.DECODE_ANAPRES_ANAPRES_SISS_COD ??
                  props.methodsDistr.getValues("codiceSiss") ??
                  "",
                GPDISTR_CODICE:
                  data?.GPDISTR_CODICE ??
                  props.methodsDistr.getValues("distretto"),
                MEDPRSTGPD_SW_DISABILITATO: props.methodsDistr.getValues(
                  "abbDisatt",
                )
                  ? "1"
                  : "0",
                MEDPRSTGPD_PID_ACU: "0",
                MEDPRSTGPD_TIMESTAMP: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
                MEDPRSTGPD_OP_LOGICO: props.methodsDistr.getValues("opLogico"),
                MEDPRSTGPD_DT_INI_VAL: validDataIni.isValid()
                  ? validDataIni.format("YYYY-MM-DD")
                  : "",
                MEDPRSTGPD_DT_FINE_VAL: validDataFin.isValid()
                  ? validDataFin.format("YYYY-MM-DD")
                  : "",
              },
            },
          };

    try {
      await medprstgpd(tempObj)
        .then((response: any) => {
          props.alertProps.setAllert(true);
          props.alertProps.setMessage(response.data.messaggio);
          if (response.data.esito === "OK") {
            props.alertProps.setSeverity("success");
          } else {
            props.alertProps.setSeverity("error");
          }
        })
        .finally(() => {
          setTimeout(() => {
            props.alertProps.setAllert(false);
            props.methodsDistr.reset({
              crud: "r",
              abbDisatt: false,
              dataIni: null,
              dataFin: null,
              distretto: null,
              codiceSiss: null,
              opLogico: "U",
            });
            props.promisesHandlerAttrGp();
          }, 3000);
        });
    } catch (error) {
      console.error("Errore sull'invio del payload di medpresl:", error);
    }
  };

  // funzione per gestire alert di conferma eliminazione metodica
  const onClickCancellazioneMetodica = async (data: any) => {
    props.methodsMetod.setValue("crud", "d");
    props.alertProps.setFn(() => () => payloadMetodicaHandler(data));
    props.alertProps.setMessage(
      "Confermare eliminazione della metodica selezionata?",
    );
    props.alertProps.setSeverity("warning");
    props.alertProps.setAllert(true);
  };

  // funzione per gestire alert di conferma eliminazione distretto
  const onClickCancellazioneDistretto = async (data: any) => {
    props.methodsDistr.setValue("crud", "d");
    props.alertProps.setFn(() => () => payloadDistrettoHandler(data));
    props.alertProps.setMessage(
      "Confermare eliminazione del distretto selezionato?",
    );
    props.alertProps.setSeverity("warning");
    props.alertProps.setAllert(true);
  };

  return (
    <>
      <Modal open={props.showModale}>
        <Box
          sx={{
            maxHeight: "90vh",
            maxWidth: "90vh",
            width: "50%",
            overflow: "auto",
            paddingTop: 2,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {modalsView === "base" && (
            <>
              <Tabs value={0} sx={{ paddingLeft: 2, mb: 2 }}>
                <Tab
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                  label={
                    defaultView
                      ? "Elenco attributi della prestazione"
                      : "Default attributi della prestazione"
                  }
                />
              </Tabs>
              <Grid
                container
                spacing={2}
                pl={2}
                pb={2}
                pr={2}
                justifyContent="center"
              >
                {defaultView && (
                  <>
                    <Grid item xs={6}>
                      <RHFTextField
                        control={props.methodsMedDettaglio.control}
                        name="medico"
                        label="Medico"
                        placeholder="Medico"
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <RHFTextField
                        control={props.methodsMedDettaglio.control}
                        name="specialita"
                        label="Specialità"
                        placeholder="Specialità"
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <RHFTextField
                        control={props.methodsMedDettaglio.control}
                        name="prestazione"
                        label="Prestazione"
                        placeholder="Prestazione"
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <RHFTextField
                        control={props.methodsMedDettaglio.control}
                        name="tipologia"
                        label="Tipologia"
                        placeholder="Tipologia"
                        fullWidth
                        disabled
                      />
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  display={"flex"}
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid #CCC",
                    ml: 2,
                    mt: 2,
                    pb: 2,
                    pr: 2,
                  }}
                >
                  <TabsAttributiPres
                    loading={props.loading}
                    showModale={props.showModale}
                    setShowModale={props.setShowModale}
                    submitFunction={props.submitFunction}
                    listDistAssoc={props.listDistAssoc}
                    listMetodAssoc={props.listMetodAssoc}
                    listDistDefault={props.listDistDefault}
                    listMetodDefault={props.listMetodDefault}
                    methods={props.methods}
                    methodsDistr={props.methodsDistr}
                    methodsMetod={props.methodsMetod}
                    distrettiSelected={distrettiSelected}
                    setDistrettiSelected={setDistrettiSelected}
                    metodicheSelected={metodicheSelected}
                    setMetodicheSelected={setMetodicheSelected}
                    defaultView={defaultView}
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    setModalsView={setModalsView}
                    payloadMetodicaHandler={payloadMetodicaHandler}
                    payloadDistrettoHandler={payloadDistrettoHandler}
                    deleteRequestMetodica={onClickCancellazioneMetodica}
                    deleteRequestDistretti={onClickCancellazioneDistretto}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="space-between">
                    {defaultView ? (
                      <>
                        <Button
                          variant="outlinedError"
                          onClick={() => props.setShowModale(false)}
                        >
                          Uscita
                        </Button>

                        <Button
                          type="submit"
                          variant="contained"
                          onClick={() => setDefaultView(!defaultView)}
                        >
                          Vis. Default
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setDefaultView(true);
                            setDistrettiSelected([]);
                            setMetodicheSelected([]);
                          }}
                        >
                          Indietro
                        </Button>

                        <Button
                          type="submit"
                          variant="contained"
                          onClick={
                            selectedTab === 0
                              ? props.methods.handleSubmit(async () => {
                                  props.methodsDistr.setValue("crud", "c");
                                  const tempList = distrettiSelected ?? [];
                                  await Promise.all(
                                    tempList.map((e) =>
                                      payloadDistrettoHandler({
                                        DECODE_ANAPRES_ANAPRES_SISS_COD:
                                          e.DECODE_ANAPRES_ANAPRES_SISS_COD,
                                        GPDISTR_CODICE: e.GPDISTR_CODICE,
                                        DATAINIVAL: "",
                                        DATAFINEVAL: "",
                                      }),
                                    ),
                                  ).finally(() => {
                                    setDefaultView(true);
                                    setDistrettiSelected([]);
                                  });
                                })
                              : props.methods.handleSubmit(async () => {
                                  props.methodsMetod.setValue("crud", "c");
                                  const tempList = metodicheSelected ?? [];
                                  await Promise.all(
                                    tempList.map((e) =>
                                      payloadMetodicaHandler({
                                        DECODE_ANAPRES_ANAPRES_SISS_COD:
                                          e.DECODE_ANAPRES_ANAPRES_SISS_COD,
                                        GPMETOD_CODICE: e.GPMETOD_CODICE,
                                        DATAINIVAL: "",
                                        DATAFINEVAL: "",
                                      }),
                                    ),
                                  ).finally(() => {
                                    setDefaultView(true);
                                    setMetodicheSelected([]);
                                  });
                                })
                          }
                        >
                          Importa
                        </Button>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </>
          )}
          {modalsView === "distretti" && (
            <DistrettoModal
              loading={props.loading}
              methods={props.methodsDistr}
              setModalsView={setModalsView}
              submitFunction={props.submitFunction}
              codiciSiss={props.codiciSiss}
              payloadDistrettoHandler={payloadDistrettoHandler}
            />
          )}
          {modalsView === "metodiche" && (
            <MetodicaModal
              loading={props.loading}
              methods={props.methodsMetod}
              setModalsView={setModalsView}
              submitFunction={props.submitFunction}
              codiciSiss={props.codiciSiss}
              payloadMetodicaHandler={payloadMetodicaHandler}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};

export default AttributiGpModal;
